export enum PlaylistProperties {
  Name = 'name',
  Description = 'description',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  IsPrivate = 'isPrivate',
  ProcessedMedia = 'processedMedia',
  Media = 'media',
  ReleaseZone = 'releaseZone',
}
export enum PlaylistMetaProperties {
  ProcessedMediaId = 'ProcessedMedia-id',
  ProcessedMediaVersion = 'ProcessedMedia-version',
  MediaId = 'Media-id',
  MediaVersion = 'Media-version',
  ReleaseZoneId = 'ReleaseZone-id',
  ReleaseZoneVersion = 'ReleaseZone-version',
}
